var mapFunctions = (function($){

return {
	initMaps: function(){
		var map = null;
		$('.google-map').each(function(){
			map = new_map( $(this) );
		});
	}
}

function new_map( $el ) {

	// var
	var $markers = $el.find('.marker');

	// vars
	var args = {
		zoom				: 16,
		center				: new google.maps.LatLng(0, 0),
		mapTypeId			: google.maps.MapTypeId.ROADMAP,
		disableDefaultUI	: false,
		styles				: [ {"featureType": "all", "elementType": "labels.text.fill", "stylers": [{"color": "#ffffff"} ] }, {"featureType": "all", "elementType": "labels.text.stroke", "stylers": [{"lightness": 13 }, {"color": "#000000"} ] }, {"featureType": "administrative", "elementType": "geometry.fill", "stylers": [{"color": "#000000"} ] }, {"featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{"color": "#144b53"}, {"lightness": 14 }, {"weight": 1.4 } ] }, {"featureType": "landscape", "elementType": "all", "stylers": [{"color": "#08304b"} ] }, {"featureType": "poi", "elementType": "all", "stylers": [{"visibility": "off"} ] }, {"featureType": "poi", "elementType": "geometry", "stylers": [{"color": "#0c4152"}, {"lightness": 5 } ] }, {"featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{"color": "#000000"} ] }, {"featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{"color": "#0b434f"}, {"lightness": 25 } ] }, {"featureType": "road.arterial", "elementType": "geometry.fill", "stylers": [{"color": "#000000"} ] }, {"featureType": "road.arterial", "elementType": "geometry.stroke", "stylers": [{"color": "#0b3d51"}, {"lightness": 16 } ] }, {"featureType": "road.local", "elementType": "geometry", "stylers": [{"color": "#000000"} ] }, {"featureType": "transit", "elementType": "all", "stylers": [{"color": "#437984"} ] }, {"featureType": "transit", "elementType": "labels.text.fill", "stylers": [{"color": "#ffffff"} ] }, {"featureType": "transit", "elementType": "labels.text.stroke", "stylers": [{"color": "#000000"} ] }, {"featureType": "water", "elementType": "all", "stylers": [{"color": "#021019"} ] } ],
	};

	// create map
	var map = new google.maps.Map( $el[0], args);
	// add a markers reference
	map.markers = [];

	// add markers
	$markers.each(function(){
    	add_marker( $(this), map );
	});

	// center map
	center_map( map );
	// return
	return map;
}

function add_marker( $marker, map ) {
	// var
	var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

	// create marker
	if ($('.single-property').length){
		var iconWidth = 34;
		var iconHeight = 45;
	}else{
		var iconWidth = 56;
		var iconHeight = 75;
	}
	var icon = {
		url: vars.themeurl + '/img/ui/map-marker.svg',
		size: new google.maps.Size(iconWidth, iconHeight),
      	scaledSize: new google.maps.Size(iconWidth, iconHeight),
      	anchor: new google.maps.Point(iconWidth/2, iconHeight),
      	origin: new google.maps.Point(0, 0),
	}
	var marker = new google.maps.Marker({
		position	: latlng,
		map			: map,
		icon		: icon,
	});

	// add to array
	map.markers.push( marker );

	// if marker contains HTML, add it to an infoWindow
	if( $marker.html() ){
		// create info window
		var infowindow = new google.maps.InfoWindow({
			content: $marker.html()
		});

		// show info window when marker is clicked
		google.maps.event.addListener(marker, 'click', function() {
			infowindow.open( map, marker );
		});
	}
}

function center_map( map ) {
	// vars
	var bounds = new google.maps.LatLngBounds();

	// loop through all markers and create bounds
	$.each( map.markers, function( i, marker ){
		var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
		bounds.extend( latlng );
	});

	// only 1 marker?
	if( map.markers.length == 1 ){
		// set center of map
	    map.setCenter( bounds.getCenter() );
	    map.setZoom( 16 );
	}else{
		var listener = google.maps.event.addListenerOnce(map, "idle", function(){
			map.setZoom(map.getZoom() - 2);
		});
		map.fitBounds( bounds );
	}
}

})(jQuery);